import React from 'react';
import { useLang } from '../context/LanguageContext';

const LanguageModal = () => {
  const { rawLang, setLang, t } = useLang();

  if (rawLang) return null;

  const langs = [
    { code: 'nl', label: 'Nederlands' },
    { code: 'en', label: 'English' },
    { code: 'fr', label: 'Français' }
  ];

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 backdrop-blur-sm" data-testid="language-modal">
      <div className="bg-[#04140e] border-2 border-[#c5a059] rounded-sm p-10 max-w-md w-full mx-6 shadow-2xl fade-up">
        <div className="text-center mb-8">
          <h2 className="text-3xl font-serif font-bold text-[#c5a059] mb-2">{t.langModal.title}</h2>
          <div className="w-16 h-px bg-[#c5a059] mx-auto my-3"></div>
          <p className="text-sm text-white/60">{t.langModal.subtitle}</p>
        </div>
        <div className="space-y-3">
          {langs.map((l) => (
            <button
              key={l.code}
              onClick={() => setLang(l.code)}
              data-testid={`lang-select-${l.code}`}
              className="w-full flex items-center justify-between px-6 py-4 border border-[#c5a059]/40 hover:border-[#c5a059] hover:bg-[#c5a059]/10 transition-colors rounded-sm group"
            >
              <span className="font-medium text-[#f5e9ce]">{l.label}</span>
              <span className="text-[#c5a059] opacity-0 group-hover:opacity-100 transition-opacity">→</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LanguageModal;
